var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import deepEqual from 'fast-deep-equal';
var flattenNodeData = function (nodeData) {
    return nodeData.reduce(function (acc, node) {
        acc.push.apply(acc, node.getDescendants());
        return acc;
    }, []);
};
var NodeData = /** @class */ (function () {
    function NodeData(data, id, depth, isAsync) {
        if (depth === void 0) { depth = 0; }
        this.data = data;
        this.id = id;
        this.depth = depth;
        if (isAsync) {
            this.isAsync = function () {
                return isAsync(this);
            };
        }
    }
    NodeData.createHierarchy = function (data, idAccessor, childrenAccessor, isAsync) {
        var _a;
        var root = data.map(function (data) { return new NodeData(data, idAccessor(data), 0, isAsync); });
        var current;
        var visitors = __spreadArrays(root);
        while ((current = visitors.pop())) {
            current.children = (_a = childrenAccessor(current.data)) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                var _a;
                var newNode = new NodeData(item, idAccessor(item), ((_a = current === null || current === void 0 ? void 0 : current.depth) !== null && _a !== void 0 ? _a : 0) + 1, isAsync);
                newNode.parent = current;
                return newNode;
            });
            visitors.push.apply(visitors, (current.children || []));
        }
        return root;
    };
    NodeData.equal = function (nodesA, nodesB, mapper) {
        if (mapper === void 0) { mapper = function (node) {
            var _a;
            return ({
                id: node.id,
                parentId: (_a = node.parent) === null || _a === void 0 ? void 0 : _a.id,
                data: node.data
            });
        }; }
        return deepEqual(mapper(nodesA), mapper(nodesB));
    };
    NodeData.equalNodes = function (nodesA, nodesB, mapper) {
        if (mapper === void 0) { mapper = function (node) {
            var _a;
            return ({
                id: node.id,
                parentId: (_a = node.parent) === null || _a === void 0 ? void 0 : _a.id
            });
        }; }
        return deepEqual(flattenNodeData(nodesA).map(mapper), flattenNodeData(nodesB).map(mapper));
    };
    NodeData.prototype.preorderTraverse = function (callback) {
        var _a, _b;
        var current;
        var visitors = ((_a = this.children) !== null && _a !== void 0 ? _a : []).slice().reverse();
        while ((current = visitors.pop())) {
            callback(current);
            visitors.push.apply(visitors, ((_b = current.children) !== null && _b !== void 0 ? _b : []).slice().reverse());
        }
    };
    NodeData.prototype.getById = function (id) {
        var _a, _b;
        var current;
        var visitors = ((_a = this.children) !== null && _a !== void 0 ? _a : []).slice().reverse();
        while ((current = visitors.pop())) {
            if (current.id === id) {
                return current;
            }
            visitors.push.apply(visitors, ((_b = current.children) !== null && _b !== void 0 ? _b : []).slice().reverse());
        }
        return;
    };
    NodeData.prototype.getLeaves = function () {
        var leaves = [];
        this.preorderTraverse(function (node) {
            if (!node.children) {
                leaves.push(node);
            }
        });
        return leaves;
    };
    NodeData.prototype.getAncestors = function () {
        var parent = this.parent;
        var ancestors = [this];
        while (parent) {
            ancestors.push(parent);
            parent = parent.parent;
        }
        return ancestors;
    };
    NodeData.prototype.getDescendants = function () {
        var descendants = [this];
        this.preorderTraverse(function (descendant) {
            descendants.push(descendant);
        });
        return descendants;
    };
    NodeData.prototype.getSiblings = function () {
        var _this = this;
        var _a, _b;
        var siblings = [];
        (_b = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.forEach(function (sibling) {
            if (sibling !== _this) {
                siblings.push(sibling);
            }
        });
        return siblings;
    };
    NodeData.prototype.isTerminal = function () {
        var _a;
        return this.isAsync() ? false : !((_a = this.children) === null || _a === void 0 ? void 0 : _a.length);
    };
    NodeData.prototype.isAsync = function () {
        return false;
    };
    return NodeData;
}());
export { NodeData };
//# sourceMappingURL=nodeData.js.map